import { Box, Collapse, Grid } from "@mui/material";
import { useState } from "react";

import MetricCard from "./MetricCard";
import PracticeBreakdownTable from "./PracticeBreakdownTable";
import type { MetricCardData } from "./types";

interface MetricCardsSectionProps {
  metrics: MetricCardData[];
}

export default function MetricCardsSection({
  metrics,
}: MetricCardsSectionProps) {
  const [expandedAgent, setExpandedAgent] = useState<string | null>(null);

  const handleToggle = (agent: string) => {
    setExpandedAgent((prev) => (prev === agent ? null : agent));
  };

  const expandedMetric = expandedAgent
    ? metrics.find((m) => m.agent === expandedAgent)
    : null;

  return (
    <Box sx={{ mb: 4, width: "100%", px: 4 }}>
      <Grid
        container
        spacing={3}
        sx={{ width: "100%", alignItems: "flex-start" }}
      >
        {metrics.map((metric) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={3}
            key={metric.agent}
            sx={{ display: "flex", alignItems: "flex-start" }}
          >
            <MetricCard
              agent={metric.agent}
              displayName={metric.displayName}
              color={metric.color}
              iconUrl={metric.iconUrl}
              primaryValue={metric.primaryValue}
              description={metric.description}
              lastUpdatedAt={metric.lastUpdatedAt}
              practiceBreakdown={metric.practiceBreakdown}
              expanded={expandedAgent === metric.agent}
              onToggle={() => handleToggle(metric.agent)}
            />
          </Grid>
        ))}
      </Grid>

      <Collapse in={!!expandedMetric} timeout="auto" unmountOnExit>
        {expandedMetric && (
          <PracticeBreakdownTable
            practiceBreakdown={expandedMetric.practiceBreakdown}
            color={expandedMetric.color}
            description={expandedMetric.description}
          />
        )}
      </Collapse>
    </Box>
  );
}
